<template>
	<div style="margin-left: 30px;color: white">
		<div v-if="myData" style="display: flex;">
			<div class="profile">
				<img v-if="myData.sex=='男'" src="/img/icons8-male-48.png" alt="">
				<img v-else src="/img/icons8-female-48.png" alt="">
				<span class="name">{{user.name}}</span>
			</div>
			<div style="margin-right: 10px;padding-right: 10px;border-right: 1px solid gray;">
				<div>部门：{{user.deptName}}</div>
				<div>职位：{{myData.zwmc}}</div>
			</div>
			<div>
				<span style="font-size: 26px;">总检测</span>
				<span style="font-size: 40px;color: #417CD9;line-height: 36px;margin: 0 5px;">53</span>
				<span style="font-size: 26px">次</span>
			</div>
		</div>
		<div style="margin-top: 30px;border-top: 1px solid gray;padding: 30px 0;">
			<div style="display: flex;margin-bottom: 10px;">
				<div style="display: flex;align-items: center;">
					<div style="font-size: 40px;color: #31FC76;line-height: 36px;margin-right: 10px;">{{averageHeartRate}}</div>
					<img style="width: 20px;height: 20px;margin-right: 5px" src="/img/icons8-heart-50.png" alt="">
					<div>近期平均心率</div>
				</div>
			</div>
			<h3 class="subheading">最近心率</h3>
			<div>
				<div id="heartRate" style="width: 100%;height: 200px;">
				</div>
			</div>
		</div>
		<div style="display: flex;margin-bottom: 10px;">
			<div style="display: flex;align-items: center;margin-right: 30px;">
				<div style="font-size: 40px;color: #31FC76;line-height: 36px;margin-right: 10px;">{{averageBloodPressure_l}}</div>
				<img style="width: 20px;height: 20px;margin-right: 5px" src="/img/icons8-blood-pressure-32.png" alt="">
				<div>近期平均舒张压</div>
			</div>
			<div style="display: flex;align-items: center;">
				<div style="font-size: 40px;color: #31FC76;line-height: 36px;margin-right: 10px;">{{averageBloodPressure_h}}</div>
				<img style="width: 20px;height: 20px;margin-right: 5px" src="/img/icons8-blood-pressure-32.png" alt="">
				<div>近期平均收缩压</div>
			</div>
		</div>
		<h3 class="subheading">最近血压</h3>
		<div>
			<div id="bloodPressure" style="width: 100%;height: 300px;">
			</div>
		</div>
	</div>
</template>
<script>
import {PeoAnalyse} from "@/api/personcenter";

var echarts = require('echarts');
export default {
	data() {
		return {
			myData: null,
			user: JSON.parse(this.$store.state.User.infos),
		};
	},
	created() {
	},
	mounted() {
		PeoAnalyse({userId:this.user.id}).then(res => {
			console.log(res.result);
			let data = res.result;
			this.myData = data;
			this.init1()
			this.init2()
		})
	},
	computed: {
		averageHeartRate() {
			if (!this.myData) return
			let sum = 0;
			this.myData.list_hr.forEach(item => {
				sum += item.val;
			})
			return (sum / this.myData.list_hr.length).toFixed(1);
		},
		averageBloodPressure_h() {
			if (!this.myData) return
			let sum = 0;
			this.myData.list_bp_h.forEach(item => {
				sum += item.val;
			})
			return (sum / this.myData.list_bp_h.length).toFixed(1);
		},
		averageBloodPressure_l() {
			if (!this.myData) return
			let sum = 0;
			this.myData.list_bp_l.forEach(item => {
				sum += item.val;
			})
			return (sum / this.myData.list_bp_l.length).toFixed(1);
		}
	},
	watch: {
	},
	methods: {
		init1() {
			var chartDom = document.getElementById('heartRate');
			var myChart = echarts.init(chartDom);

			let option;
			option = {
				xAxis: {
					type: 'category',
					data: this.myData.list_hr.map(item => {
						return item.name;
					}),
				},
				yAxis: {
					type: 'value'
				},
				grid: {
					top: '10%',
					right: '5%',
					bottom: '5%',
					left: '5%',
					containLabel: true
				},
				series: [
					{
						data: this.myData.list_hr.map(item => {
							return item.val;
						}),
						type: 'scatter',
						symbol: 'roundRect',
						symbolSize: [10,12],
						itemStyle: {
							color: '#06A4F1',
							borderRadius: 5
						}
					}
				]
			};
			myChart.setOption(option);
		},
		init2() {
			var chartDom = document.getElementById('bloodPressure');
			var myChart = echarts.init(chartDom);
			let option;
			option = {
				legend: {
					// top: '0%',
					left: 'center',
					textStyle: {
						color: 'white',
						fontSize: 14
					},
				},
				xAxis: {
					type: 'category',
					data: this.myData.list_bp_l.map(item => {
						return item.name;
					})
				},
				yAxis: {
					type: 'value',
					splitLine: {
						lineStyle: {
							color: '#ccc', // 网格线颜色
							width: 1,      // 线宽
							type: 'solid',  // 线型（solid/dashed/dotted）
							opacity: 0.5
						},
					},
					splitNumber: 5
				},
				grid: {
					top: '20%',
					right: '5%',
					bottom: '5%',
					left: '5%',
					containLabel: true
				},
				series: [
					{
						name: '收缩压(高压)',
						type: 'line',
						data: this.myData.list_bp_h.map(item => {
							return item.val;
						}),
						lineStyle: {
							color: '#FE7E56',
						},
						smooth: true,
						showSymbol: false,
					},
					{
						name: '舒张压(低压)',
						type: 'line',
						data: this.myData.list_bp_l.map(item => {
							return item.val;
						}),
						lineStyle: {
							color: '#1B96D0',
						},
						smooth: true,
						showSymbol: false,
					},
				]
			};
			myChart.setOption(option);
		}
	},
};
</script>
<style scoped lang="less">
.profile {
	display: flex;
	align-items: flex-start;
	color: white;
	border-right: 1px solid gray;
	margin-right: 20px;
	padding-right: 20px;
	.name {
		font-size: 30px;
		margin-left: 20px;
	}
}
.subheading {
	color: white;
	padding: 5px 10px;
	margin-top: 10px;
	margin-bottom: 0;
	border-left: 8px solid transparent; /* 边框宽度 + 透明 */
	border-image: linear-gradient(0deg, #7E237E, #1D21A4);
	border-image-slice: 1; /* 表示渐变图片如何切割，通常设为1 */
}
</style>